import { cn, PictogramIcon } from '@speedlo/ui'
import React from 'react'
import styled from 'styled-components/macro'

import { MapClickableContent } from '../components/Map/MapClickableContent'
import { MapMarker } from '../components/Map/MapMarker'
import { FPickupBranchFragment } from '../graph/generated'

type TProps = NoChildren & {
  branch: FPickupBranchFragment
  onClick?: () => void
}

const StyledPickupMapMarker = styled.div`
  --dimensions: 2.4rem;

  color: white;
  opacity: 0.5;

  background-color: #ff0000;
  border-radius: 50%;

  height: var(--dimensions);
  width: var(--dimensions);

  display: grid;
  justify-content: center;
  align-items: center;

  .clickable {
    cursor: pointer;
  }
`

export const MapBranchMarker: React.FC<TProps> = ({ branch, onClick }) => {
  const isInteractive = Boolean(onClick)

  const branchIcon = React.useMemo(() => {
    return (
      <StyledPickupMapMarker data-testid="PickupMapMarker">
        <PictogramIcon
          size={1.3}
          icon="restaurant"
          onClick={onClick}
          title={branch.name}
          className={cn({ clickable: isInteractive })}
        />
      </StyledPickupMapMarker>
    )
  }, [branch.name, isInteractive, onClick])

  return isInteractive ? (
    <MapMarker position={branch.gps}>
      <MapClickableContent>{branchIcon}</MapClickableContent>
    </MapMarker>
  ) : (
    <MapMarker position={branch.gps}>{branchIcon}</MapMarker>
  )
}
